import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "safe-area" }
const _hoisted_2 = { class: "pages-container" }
const _hoisted_3 = {
  key: 0,
  class: "bottom-nav"
}

import { onMounted, ref, watch, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { initTelegram, requestFullscreen, getSafeAreaInsets, isMobileDevice } from './utils/telegram';
import { haptic } from './utils/telegram';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

_useCssVars(_ctx => ({
  "4851fef0": (safeArea.value.top.value + safeArea.value.top.unit),
  "396ecfd9": (safeArea.value.right?.value + (safeArea.value.right?.unit ?? "px")),
  "9208f836": (safeArea.value.bottom?.value + (safeArea.value.bottom?.unit ?? "px")),
  "b4539ea6": (safeArea.value.left?.value + (safeArea.value.left?.unit ?? "px"))
}))

const router = useRouter();
const route = useRoute();
const transitionName = ref('slide-left');

const safeArea = ref(getSafeAreaInsets({
  top: { value: isMobileDevice() ? 12 : 0, unit: 'vh' },
}));

// Определяем порядок страниц в навигации
const pageOrder: Record<string, number> = {
  '/': 0,
  '/buyVPN': 1,
  '/referal': 2,
  '/profile': 3,
  '/deposit': 10,
  '/tasks': 10,
  '/ChooseOSView': 10,
  '/payment-history': 10,
};

// Страницы где показывать bottom-nav (основные страницы)
const pagesWithNav = ['/', '/buyVPN', '/referal', '/profile'];

let previousPageIndex = 0;

const currentRoute = computed(() => route.path);

// Показывать bottom-nav только на основных страницах
const showBottomNav = computed(() => {
  return pagesWithNav.includes(route.path);
});

watch(
  () => route.path,
  (newPath, oldPath) => {
    const newIndex = pageOrder[newPath] ?? -1;
    const oldIndex = pageOrder[oldPath] ?? previousPageIndex;

    // Определяем направление анимации
    if (newIndex >= 10 && oldIndex < 10) {
      // Открытие модальной страницы
      transitionName.value = 'slide-up';
    } else if (oldIndex >= 10 && newIndex < 10) {
      // Закрытие модальной страницы
      transitionName.value = 'slide-down';
    } else if (newIndex > oldIndex) {
      // Переход вперед
      transitionName.value = 'slide-left';
    } else if (newIndex < oldIndex) {
      // Переход назад
      transitionName.value = 'slide-right';
    } else {
      // Неопределенный переход
      transitionName.value = 'fade';
    }

    previousPageIndex = newIndex !== -1 ? newIndex : oldIndex;
  }
);

const goTo = (route: string) => {
  haptic.impact();
  router.push(`/${route}`);
};

// ✅ ИСПРАВЛЕНО: Асинхронная инициализация с обработкой ошибок
onMounted(async () => {
  try {
    console.log('🚀 Starting Telegram initialization...');

    // Ждём загрузки и инициализации Telegram SDK
    await initTelegram();

    // После успешной инициализации запрашиваем fullscreen
    requestFullscreen();

    console.log('✅ App.vue: Telegram initialized successfully');
  } catch (error) {
    console.error('❌ App.vue: Failed to initialize Telegram:', error);

    // Можно показать fallback UI или уведомление пользователю
    // alert('Не удалось инициализировать Telegram WebApp. Пожалуйста, откройте приложение через Telegram.');
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component, route }) => [
          _createVNode(_Transition, {
            name: transitionName.value,
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                key: route.path
              }))
            ]),
            _: 2
          }, 1032, ["name"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_Transition, { name: "nav-slide" }, {
      default: _withCtx(() => [
        (showBottomNav.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", {
                class: _normalizeClass(["nav-item", { active: currentRoute.value === '/' }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (goTo('')))
              }, _cache[4] || (_cache[4] = [
                _createElementVNode("div", { class: "nav-icon" }, "🏠", -1),
                _createElementVNode("div", { class: "nav-label" }, "Главная", -1)
              ]), 2),
              _createElementVNode("div", {
                class: _normalizeClass(["nav-item", { active: currentRoute.value === '/buyVPN' }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (goTo('buyVPN')))
              }, _cache[5] || (_cache[5] = [
                _createElementVNode("div", { class: "nav-icon" }, "🛒", -1),
                _createElementVNode("div", { class: "nav-label" }, "Купить", -1)
              ]), 2),
              _createElementVNode("div", {
                class: _normalizeClass(["nav-item", { active: currentRoute.value === '/referal' }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (goTo('referal')))
              }, _cache[6] || (_cache[6] = [
                _createElementVNode("div", { class: "nav-icon" }, "🎁", -1),
                _createElementVNode("div", { class: "nav-label" }, "Реферал", -1)
              ]), 2),
              _createElementVNode("div", {
                class: _normalizeClass(["nav-item", { active: currentRoute.value === '/profile' }]),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (goTo('profile')))
              }, _cache[7] || (_cache[7] = [
                _createElementVNode("div", { class: "nav-icon" }, "👤", -1),
                _createElementVNode("div", { class: "nav-label" }, "Профиль", -1)
              ]), 2)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})